import type { AlertValues } from "@nabla/api";
import { unitsOf } from "../../features/campaign/parts/words.ts";
import { stockRuleCopy as t } from "./copy.ts";

export const alerts = {
  "estoque-baixo": {
    says: (v: AlertValues<"estoque-baixo">) => t.alerta(v.produto, unitsOf(v.unidades), String(v.limite), v.anuncios),
    next: t.proximo,
  },
};
